export const SOURCE_VIEW_QUERY_PARAM_KEY = 'sourceView';
export const SOURCE_VIEW_DISPLAY = 'display';
